import { Loader, Skeleton } from '@mantine/core'
import { translate } from 'i18n/i18n'

export const SoilSkeleton = () => (
  <div>
    <div css={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
      <h3 css={{ margin: 0 }}>{translate.phrases.banyanApp('Soil Moisture & Infiltration')}</h3>
      <Loader size="sm" color="blue" />
    </div>
    <Skeleton height={400} radius="sm" animate />
  </div>
)
